import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { InspectionHttpCreateRequestModel } from '../httpQueue/inspection/types';
import { InspectionOutDto } from 'shared/dtos/out/inspection';

export class InspectionSaver {
  constructor(
    private addRequest: (
      request: InspectionHttpCreateRequestModel
    ) => Promise<any>
  ) {}

  async execute(
    templateId: string,
    inspectionOutDto: InspectionOutDto,
    projectId: string,
    uniqueId: string,
  ): Promise<void> {
    debugLog('InspectionSaver', templateId, inspectionOutDto);
    await this.addRequest({
      createdAt: Date.now(),
      method: 'POST',
      data: {
        templateId,
        inspectionOutDto,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/inspection`,
      entityType: HttpRequestModelType.inspection,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionSaver = new InspectionSaver(addRequest);
